<template>
  <component :is="icon" :fill="color" :width="width" :height="height" class="fill-current" />
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from 'vue';
import hamburger from '@/assets/icons/icon-hamburger.svg';
import arrowDown from '@/assets/icons/icon-arrow-down.svg';
import arrowRight from '@/assets/icons/icon-arrow-right.svg';
import close from '@/assets/icons/icon-close.svg';
import colianLogo from '@/assets/icons/icon-colian-logo.svg';
import phone from '@/assets/icons/icon-phone.svg';
import user from '@/assets/icons/icon-user.svg';
import trash from '@/assets/icons/icon-trash.svg';
import edit from '@/assets/icons/icon-edit.svg';
import tick from '@/assets/icons/icon-tick.svg';
import eye from '@/assets/icons/icon-eye.svg';
import image from '@/assets/icons/icon-image.svg';

export type TIcon =
	'hamburger' |
	'arrowDown' |
	'arrowRight' |
	'colianLogo' |
	'phone' |
	'user' |
	'trash' |
	'edit' |
	'tick' |
	'eye' |
	'image' |
	'close'

interface IOwnProps {
	icon: TIcon
	color?: string
	width?: string
	height?: string
	gradient?: boolean
}
interface IProps extends IOwnProps {
}

const props = withDefaults(defineProps<IProps>(), {
    height: '16',
    width: '16',
    gradient: false,
    color: 'white'
});

let icon: string | null = null;

switch (props.icon) {
	case 'hamburger':
		icon = hamburger;
		break;
	case 'arrowDown':
		icon = arrowDown;
		break;
	case 'arrowRight':
		icon = arrowRight;
		break;
	case 'close':
		icon = close;
		break;
	case 'colianLogo':
		icon = colianLogo;
		break;
	case 'phone':
		icon = phone;
		break;
	case 'user':
		icon = user;
		break;
	case 'trash':
		icon = trash;
		break;
	case 'edit':
		icon = edit;
		break;
	case 'tick':
		icon = tick;
		break;
	case 'eye':
		icon = eye;
		break;
	case 'image':
		icon = image;
		break;
	default :
		icon = close;
}

</script>

<style scoped>
svg.icon {
    vertical-align: middle;
    padding: 0;
    display: inline-block;
}
</style>
